/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { liveChatMyChatsEntryPoint } from '@jira/spa-apps__servicedesk-live-chat-my-chats/src/liveChatMyChatsEntryPoint.entrypoint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskIssueTypesResource } from '@jira/router-resources__service-desk-issue-types/src/servicedeskIssueTypesResource.tsx';
import { servicedeskLiveChatMyChatsRoute } from '@jira/router-routes__servicedesk-live-chat-routes/src/servicedeskLiveChatMyChatsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const liveChatMyChatsPageEntryPoint = createPageEntryPoint({
	main: liveChatMyChatsEntryPoint,
});

export const servicedeskLiveChatMyChatsRouteEntry: Route = createEntry(
	servicedeskLiveChatMyChatsRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,
		perfMetricKey: 'servicedesk-live-chat-my-chats-load',

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			staticProjectSidebarNavigationResource,
			getConsolidationStateResource(),
			servicedeskIssueTypesResource,
		],

		entryPoint() {
			return fg('live-chat-rovo-for-service') ? liveChatMyChatsPageEntryPoint : undefined;
		},

		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
